module.exports = {
	"_args": [
		[
			"truffle-contract-schema@2.0.1",
			"/Users/billhsu/Desktop/work/github/cypherpunks-ctf"
		]
	],
	"_from": "truffle-contract-schema@2.0.1",
	"_id": "truffle-contract-schema@2.0.1",
	"_inBundle": false,
	"_integrity": "sha1-m/gh0y4m5nS6FetdQPlrELHJ1Wg=",
	"_location": "/truffle-contract-schema",
	"_phantomChildren": {},
	"_requested": {
		"type": "version",
		"registry": true,
		"raw": "truffle-contract-schema@2.0.1",
		"name": "truffle-contract-schema",
		"escapedName": "truffle-contract-schema",
		"rawSpec": "2.0.1",
		"saveSpec": null,
		"fetchSpec": "2.0.1"
	},
	"_requiredBy": [
		"/truffle-contract"
	],
	"_resolved": "https://registry.npmjs.org/truffle-contract-schema/-/truffle-contract-schema-2.0.1.tgz",
	"_spec": "2.0.1",
	"_where": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf",
	"author": {
		"name": "Tim Coulter",
		"email": "tim.coulter@consensys.net"
	},
	"bugs": {
		"url": "https://github.com/trufflesuite/truffle-schema/issues"
	},
	"dependencies": {
		"ajv": "^5.1.1",
		"crypto-js": "^3.1.9-1",
		"debug": "^3.1.0"
	},
	"description": "JSON schema for contract artifacts",
	"devDependencies": {
		"mocha": "5.2.0",
		"solc": "0.4.24"
	},
	"homepage": "https://github.com/trufflesuite/truffle-schema#readme",
	"keywords": [
		"ethereum",
		"json",
		"schema",
		"contract",
		"artifacts"
	],
	"license": "MIT",
	"main": "index.js",
	"name": "truffle-contract-schema",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/trufflesuite/truffle-schema.git"
	},
	"scripts": {
		"test": "mocha"
	},
	"version": "2.0.1"
};


//////////////////
// WEBPACK FOOTER
// ./~/truffle-contract-schema/package.json
// module id = 1066
// module chunks = 0